/**
 * 2022-01-14
 * 带图片切换标签页组件：SwitchTabWithImage
 */
import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { useState } from 'react';
import css from './index.module.scss';
const defaultStyle = {
    position: 'top',
    backColor: '#fff',
    height: 'auto',
};

const defaultData = [
    {
        tab: 'Home Backup',
        key: 'k1',
        arr: [
            {
                key: 'code1',
                images: '/img/productDetails/riverpro/light.png',
                name: 'Light',
                value: '65.2',
            },
            {
                key: 'code2',
                images: '/img/productDetails/riverpro/cpap.png',
                name: 'CPAP',
                value: '12',
            },
            {
                key: 'code3',
                images: '/img/productDetails/riverpro/refrigerator.png',
                name: 'Refrigerator',
                value: '4.5',
            },
            {
                key: 'code4',
                images: '/img/productDetails/riverpro/blender.png',
                name: 'Blender',
                value: '1.2',
            },
            {
                key: 'code5',
                images: '/img/productDetails/riverpro/tv.png',
                name: '50"TV',
                value: '5',
            },
            {
                key: 'code6',
                images: '/img/productDetails/riverpro/hairdryer.png',
                name: 'Hair Dryer',
                value: '0.7',
            },
            {
                key: 'code7',
                images: '/img/productDetails/riverpro/coffeemaker.png',
                name: 'Coffee Maker',
                value: '0.7',
            },
            {
                key: 'code8',
                images: '/img/productDetails/riverpro/projector.png',
                name: 'Projector',
                value: '8',
            },
        ],
    },
    {
        tab: 'Off-Grid Life',
        key: 'k2',
        arr: [
            {
                key: 'code1',
                images: '/img/productDetails/riverpro/light.png',
                name: 'Light',
                value: '65.2',
            },
            {
                key: 'code2',
                images: '/img/productDetails/riverpro/cpap.png',
                name: 'CPAP',
                value: '12',
            },
            {
                key: 'code3',
                images: '/img/productDetails/riverpro/refrigerator.png',
                name: 'Refrigerator',
                value: '4.5',
            },
            {
                key: 'code4',
                images: '/img/productDetails/riverpro/blender.png',
                name: 'Blender',
                value: '1.2',
            },
            {
                key: 'code5',
                images: '/img/productDetails/riverpro/tv.png',
                name: '50" TV',
                value: '5',
            },
            {
                key: 'code6',
                images: '/img/productDetails/riverpro/hairdryer.png',
                name: 'Hair Dryer',
                value: '0.7',
            },
            {
                key: 'code7',
                images: '/img/productDetails/riverpro/coffeemaker.png',
                name: 'Coffee Maker',
                value: '0.7',
            },
            {
                key: 'code8',
                images: '/img/productDetails/riverpro/projector.png',
                name: 'Projector',
                value: '8',
            },
        ],
    },
];

/**
 *
 * @param cssStyle{
 *   position: 图片/视频位置 string,  // top(default), bottom, left, right
 *   backColor: 背景色 string,
 *   height: 高度 string,
 * }
 *
 * @param data[
 * {
 * tab： tab文本,
 * subTab: tab副文本,
 * key：key值,
 * imgUrl：图片地址,
 * textTitle: 主标题文本,
 * textDesc: 说明文字文本,
 * textSupliment：补充文字文本,
 *
 * }
 * ]
 */

export default function TabModule({ cssStyle, data = defaultData }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { position, backColor, height, wordSpacing, letterSpacing } = styles;
    const [activeKey, setActiveKey] = useState(0);
    const [item, setItem] = useState(data[0]);
    const { useLang } = useGlobal();
    const { t } = useLang('product');

    const changeTab = (key: any) => {
        setItem(data.filter((list: any, k: number) => k === key)[0]);
        setActiveKey(key);
    };

    let originX = 0,
        startX = 0;
    const touchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const touchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };
    return (
        <div
            className={`${css.switchTabWithImage} switchTabWithImage font-family-semibold`}
            style={{
                background: backColor,
                height: height,
                wordSpacing: wordSpacing,
                letterSpacing: letterSpacing,
            }}
        >
            {/* 1. 顶部视频/图片 position: top */}
            {position === 'top' && (
                <div className="wrapper wrapperTop">
                    <div className={backColor === '#fff' ? 'container whiteTab' : 'container blackTab'} style={{ marginTop: '0.3rem' }}>
                        <div className="tabBox">
                            <ul className="tabsWrapper" onTouchStart={touchStart} onTouchMove={touchMove}>
                                {data.map((list: any, k: number) => (
                                    <li
                                        className={`tab font-family-semibold ${activeKey === k ? 'activeTab' : ''} ${
                                            backColor === '#fff' ? 'whiteTab' : 'blackTab'
                                        }`}
                                        key={k}
                                        onClick={() => activeKey !== k && changeTab(k)}
                                    >
                                        {list.tab}
                                    </li>
                                ))}
                                <p className="line" style={{ opacity: backColor === '#fff' ? '1' : '0.2' }}></p>
                            </ul>
                        </div>
                        <div className="textContainer">
                            <ul>
                                {item?.arr?.map((list: any) => (
                                    <li key={list.key}>
                                        <span className="imgs">
                                            {list.images && <Image src={list.images} width={56} height={56} alt={t(list?.name)}></Image>}
                                        </span>
                                        <span className="title">{list?.name}</span>
                                        <span>
                                            {list?.value}
                                            <b>{list.unit || ' Hrs'}</b>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
